__turbopack_context__.v({
  "support-label-reveal": "Q48sOa_support-label-reveal",
  "supportLabel": "Q48sOa_supportLabel",
});
